/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M21 3c1.6569 0 3 1.3431 3 3v13c0 1.6569-1.3431 3-3 3H3c-1.6568 0-3-1.3431-3-3V6c0-1.6569 1.3432-3 3-3h18ZM6.4425 17.5017a.75.75 0 0 1 .0558-1.0592L10.8789 12.5 6.4983 8.5575a.75.75 0 1 1 1.0034-1.115l4.9587 4.4629c.3531.3178.3531.8714 0 1.1892l-4.9587 4.4629a.75.75 0 0 1-1.0592-.0558ZM14 16.25a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5Z"
    clipRule="evenodd"
  />,
  'GQLConsoleFilled'
);
